/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleReportSourceCoverageData
 */
export interface GoogleReportSourceCoverageData {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleReportSourceCoverageData
     */
    available?: boolean;
    /**
     * Publication coverage only; null means no publication evidence. Not provider health.
     * @type {boolean}
     * @memberof GoogleReportSourceCoverageData
     */
    complete?: boolean | null;
    /**
     * 
     * @type {Array<Date>}
     * @memberof GoogleReportSourceCoverageData
     */
    observedDays?: Array<Date>;
    /**
     * 
     * @type {Array<Date>}
     * @memberof GoogleReportSourceCoverageData
     */
    publishedDays?: Array<Date> | null;
    /**
     * 
     * @type {Array<Date>}
     * @memberof GoogleReportSourceCoverageData
     */
    missingDays?: Array<Date> | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleReportSourceCoverageData
     */
    fetchedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleReportSourceCoverageData
     */
    publishedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleReportSourceCoverageData
     */
    completeness?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleReportSourceCoverageData
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleReportSourceCoverageData
     */
    timeZone?: string | null;
}

/**
 * Check if a given object implements the GoogleReportSourceCoverageData interface.
 */
export function instanceOfGoogleReportSourceCoverageData(value: object): value is GoogleReportSourceCoverageData {
    return true;
}

export function GoogleReportSourceCoverageDataFromJSON(json: any): GoogleReportSourceCoverageData {
    return GoogleReportSourceCoverageDataFromJSONTyped(json, false);
}

export function GoogleReportSourceCoverageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleReportSourceCoverageData {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'] == null ? undefined : json['available'],
        'complete': json['complete'] === undefined ? undefined : json['complete'] === null ? null : json['complete'],
        'observedDays': json['observedDays'] == null ? undefined : json['observedDays'],
        'publishedDays': json['publishedDays'] === undefined ? undefined : json['publishedDays'] === null ? null : json['publishedDays'],
        'missingDays': json['missingDays'] === undefined ? undefined : json['missingDays'] === null ? null : json['missingDays'],
        'fetchedAt': json['fetchedAt'] === undefined ? undefined : json['fetchedAt'] === null ? null : json['fetchedAt'],
        'publishedAt': json['publishedAt'] === undefined ? undefined : json['publishedAt'] === null ? null : json['publishedAt'],
        'completeness': json['completeness'] === undefined ? undefined : json['completeness'] === null ? null : json['completeness'],
        'currencyCode': json['currencyCode'] === undefined ? undefined : json['currencyCode'] === null ? null : json['currencyCode'],
        'timeZone': json['timeZone'] === undefined ? undefined : json['timeZone'] === null ? null : json['timeZone'],
    };
}

export function GoogleReportSourceCoverageDataToJSON(json: any): GoogleReportSourceCoverageData {
    return GoogleReportSourceCoverageDataToJSONTyped(json, false);
}

export function GoogleReportSourceCoverageDataToJSONTyped(value?: GoogleReportSourceCoverageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available': value['available'],
        'complete': value['complete'],
        'observedDays': value['observedDays'],
        'publishedDays': value['publishedDays'],
        'missingDays': value['missingDays'],
        'fetchedAt': value['fetchedAt'],
        'publishedAt': value['publishedAt'],
        'completeness': value['completeness'],
        'currencyCode': value['currencyCode'],
        'timeZone': value['timeZone'],
    };
}

